const DB_NAME = 'silatrail-device-records';
let connection;
export function openDraftDatabase() {
  if (!connection) connection = new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore('drafts', {keyPath: 'key'});
      request.result.createObjectStore('meta', {keyPath: 'key'});
    };
    request.onerror = () => reject(request.error);
    request.onsuccess = () => { request.result.onversionchange = () => { request.result.close(); connection = null; }; resolve(request.result); };
  }).catch(error => { connection = null; throw error; });
  return connection;
}
async function transaction(stores, action) {
  const db = await openDraftDatabase();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(stores, 'readwrite');
    let result;
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error || new Error('Device storage failed.'));
    tx.onabort = () => reject(tx.error || new Error('Device storage was interrupted.'));
    action(tx, value => { result = value; });
  });
}
export const draftStore = {
  async list(userId) {
    return transaction(['drafts'], (tx, done) => {
      const r = tx.objectStore('drafts').getAll();
      r.onsuccess = () => done(r.result.filter(x => x.data.userId === userId));
    });
  },
  async insert(draft) {
    return transaction(['drafts'], (tx, done) => {
      const s = tx.objectStore('drafts'), r = s.get(draft.key);
      r.onsuccess = () => { if (!r.result) s.add(draft); done(r.result || draft); };
    });
  },
  async update(key, userId, changes) {
    return transaction(['drafts'], tx => {
      const s = tx.objectStore('drafts'), r = s.get(key);
      r.onsuccess = () => { if (r.result?.data.userId === userId) s.put({...r.result, ...changes}); };
    });
  },
  async remove(key, userId) {
    return transaction(['drafts'], tx => {
      const s = tx.objectStore('drafts'), r = s.get(key);
      r.onsuccess = () => { if (r.result?.data.userId === userId) s.delete(key); };
    });
  },
  async importLegacy(userId, drafts) {
    return transaction(['drafts', 'meta'], tx => {
      const meta = tx.objectStore('meta'), key = `legacy:${userId}`, check = meta.get(key);
      check.onsuccess = () => {
        if (check.result) return;
        const s = tx.objectStore('drafts');
        for (const draft of drafts) { const r = s.get(draft.key); r.onsuccess = () => { if (!r.result) s.add(draft); }; }
        meta.put({key, imported: true});
      };
    });
  },
  async getMeta(key) {
    return transaction(['meta'], (tx, done) => { const r = tx.objectStore('meta').get(key); r.onsuccess = () => done(r.result?.value); });
  },
  async setMeta(key, value) { return transaction(['meta'], tx => { tx.objectStore('meta').put({key, value}); }); }
};
